import { Box, Button, Typography } from "@mui/material";
import uploadCloud from "../../../../../../src/assets/images/upload_cloud.png";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";



export const DashboardUpgradeBox = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const { nameOrg } = useParams();
    return (
        <Box sx={{
        width: "100%",
        height: "145px",
        padding: "8px 12px",
        backgroundImage: `linear-gradient(180deg, #E9EFF482 0%, #BDD0DD00 100%), url(${uploadCloud})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom right",
        borderRadius: "4px",
    }}>
        <Typography
            sx={{
                width: "132px",
                textAlign: "left",
                font: "normal normal normal 14px/18px Segoe UI",
                color: "#2D2D2D",
                marginBottom: "10px",
            }}
        >
            {t("UpgradeCard.needUpgrade")} <span style={{ fontWeight: '600' }}>{t("UpgradeCard.upgradeSpace")}</span>
        </Typography>
        <Button sx={{ color: "#22638D", borderColor: "#22638D" }} variant="outlined" onClick={() => navigate(`/${nameOrg}/adminConsole/plans`)}>
            {t("UpgradeCard.wantUpgrade")}
        </Button>
    </Box>
    );

};
